import { render, staticRenderFns } from "./manageSender.vue?vue&type=template&id=a37635a2"
import script from "./manageSender.vue?vue&type=script&lang=js"
export * from "./manageSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports